import { j as e } from "../../../../../../../jsx-runtime.BREq8dyb.js";
import { SalesforceProductType as l } from "@decentriq/graphql/dist/enums";
import { Stack as p, FormControl as f, FormLabel as x, Select as j, Option as h, Box as c, Typography as u, FormHelperText as C } from "@mui/joy";
import { memo as g } from "react";
import { b, C as y } from "../../../../../../../react-hook-form.Du3weLRK.js";
import o from "../../../../DqDatasetSyncControlledInput/DqDatasetSyncControlledInput.js";
import S from "../../labels/ConfigurationLabel/ConfigurationLabel.js";
import k from "../../labels/CredentialsLabel/CredentialsLabel.js";
const F = /* @__PURE__ */ new Map([[l.Core, "Core"], [l.MarketingCloud, "Marketing Cloud"]]), M = g(() => {
  const {
    control: d
  } = b();
  return /* @__PURE__ */ e.jsxs(p, { children: [
    /* @__PURE__ */ e.jsx(S, {}),
    /* @__PURE__ */ e.jsx(y, { control: d, name: "salesforce.productType", render: ({
      field: {
        disabled: a,
        value: m = "",
        ...t
      },
      fieldState: {
        error: s
      },
      formState: {
        isSubmitting: n
      }
    }) => /* @__PURE__ */ e.jsxs(f, { disabled: a || n, error: !!s, required: !0, children: [
      /* @__PURE__ */ e.jsx(x, { children: "Product type" }),
      /* @__PURE__ */ e.jsx(j, { ...t, disabled: a || n, onChange: (r, i) => t.onChange(i), value: m, children: Object.values(l).map((r) => /* @__PURE__ */ e.jsx(h, { disabled: r === l.MarketingCloud, value: r, children: /* @__PURE__ */ e.jsxs(c, { children: [
        /* @__PURE__ */ e.jsx(c, { children: F.get(r) }),
        r === l.MarketingCloud ? /* @__PURE__ */ e.jsx(u, { level: "body-sm", sx: {
          color: "inherit"
        }, children: "Please contact support" }) : null
      ] }) }, r)) }),
      /* @__PURE__ */ e.jsx(C, { children: s?.message })
    ] }) }, "salesforce.productType"),
    /* @__PURE__ */ e.jsx(o, { label: "My domain", name: "salesforce.domainUrl", placeholder: 'e.g. "owndomain.my.salesforce.com"' }),
    /* @__PURE__ */ e.jsx(o, { label: "Salesforce Object", name: "salesforce.apiName", placeholder: 'e.g. "CustomerList__c"' }),
    /* @__PURE__ */ e.jsx(o, { label: "Stored dataset name", name: "datasetName", placeholder: 'e.g. "DQ_dataset_name"', required: !1 }),
    /* @__PURE__ */ e.jsx(k, {}),
    /* @__PURE__ */ e.jsx(o, { label: "Client ID", name: "salesforce.credentials.clientId", placeholder: 'e.g. "4NBTEYKgiArB1Wngttv8hHxLezlGuPVYihk…"' }),
    /* @__PURE__ */ e.jsx(o, { label: "Client secret", name: "salesforce.credentials.clientSecret", placeholder: 'e.g. "EEA998BF910D4332392091999…"', type: "masked" })
  ] });
});
M.displayName = "SalesforceFormControls";
export {
  M as default
};
//# sourceMappingURL=SalesforceFormControls.js.map
